import React, { Component } from 'react';
import Room from 'material-ui/svg-icons/action/group-work';
import ScreenShare from 'material-ui/svg-icons/communication/screen-share';
import Settings from 'material-ui/svg-icons/action/settings';
import Help from 'material-ui/svg-icons/action/help-outline';
import ChatIcon from 'material-ui/svg-icons/action/question-answer';
import Video from 'material-ui/svg-icons/av/videocam';
import Drawer from 'material-ui/Drawer';
import VideoOff from 'material-ui/svg-icons/av/videocam-off';
import Mic from 'material-ui/svg-icons/av/mic';
import NotRecording from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import Recording from 'material-ui/svg-icons/toggle/radio-button-checked';
import MicOff from 'material-ui/svg-icons/av/mic-off';
import Phone from 'material-ui/svg-icons/maps/local-phone';
import IconButton from 'material-ui/IconButton';
import Clear from 'material-ui/svg-icons/content/clear';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import SeminarTabs from '../../components/SeminarTabs';
import Timer from '../../components/Timer'
import * as Sentry from '@sentry/browser';
import { isWebinar, isSpacee, checkJapanese, detectmob ,isFVlite, checkMobile, isWindows, isSentry,isSentryBreadcrumbs} from '../../lib/lib'
import ReactTooltip from 'react-tooltip';
import enhanceWithClickOutside from 'react-click-outside';
import styled from 'styled-components';
import { getTimeFromSeconds } from '../../lib/recordHelpers';

class FloatingButtons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      helpClicked: false,
      videoClicked: props.muteVideo,
      micClicked: false,
      shareClicked: false,
    }
    this.window = null
  }

  componentDidMount() {
    this.window = window.open('', '_self');
  }
  handleChange = (e, purpose) => {
    try{
      const { helpClicked, videoClicked, micClicked, shareClicked } = this.state;
      switch (purpose) {
        case 'help':
          return this.setState({ helpClicked: !helpClicked });
        case 'share':
          return this.setState({ shareClicked: !shareClicked });
        default:
          this.setState({ helpClicked, videoClicked, micClicked });
      }
    }
    catch(error){
      const message = "handleChange() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }
  handleToggle = () => {
    try{
      this.props.notify_count_reset()
      this.props.handleOpenDrawer()
    }
    catch(error){
      const message = "chat handleToggle() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  handleClose = () => {
    try{
      this.props.notify_count_reset()
      this.props.handleCloseDrawer()
    }
    catch(error){
      const message = "chat handleClose() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }

  handleClickOutside () {
    if (this.props.isOpenDrawer) {
      // this.handleClose();
    }
  }

  render () {
    const { helpClicked, videoClicked, micClicked, shareClicked } = this.state;
    return (
      <div>
        <div className='flex justify-between items-center h-100 w-100 flex-column-xs floatButton'>
            <Timer isWebinar={this.props.isWebinar} isBreakout={ (this.props.mode == "breakout" )}isCountStart={this.props.isCountStart} sessionsPremiumRoom={this.props.sessionsPremiumRoom} />
          { this.props.buttonDisplay && <div className="videoCall" style={checkMobile() ? {} : {position:'absolute', height: '8vh', bottom: "5vh", zIndex: 150,left:'50%',transform:'translateX(-50%)' }}>
            { this.props.isWebinar && !this.props.mobile && this.props.mode == "seminar" && this.props.role == "teacher" && <div  style={{display: "inline-block", marginRight: ".5rem"}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
            <FloatingActionButton
              data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `ディスカッションモードへ` : `
                    Go to Breakout Mode
                  `}
                </div>`}
              onClick={(e) => this.props.handleListClick(e, 'breakout')}
              backgroundColor='#29B87A'
              className='ml6 mr3 float-flat-button'
              style={{ width: 100, borderRadius: '40px' }}>
              <Room />
            </FloatingActionButton></div>}
            { this.props.mode == "breakout" && this.props.break_join && <div className="videoAttr" style={{display: "inline-block", marginRight: ".7rem"}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
            <FloatingActionButton
              data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    中央へ戻る
                    ` : `
                    Go Back to Main Room
                  `}
                </div>`}
              backgroundColor={'#00bcd4'}
              onClick={(e) => this.props.joinVideo(this.props.user_uid, this.props.user_name, 0, this.props.user_id,this.props.role, this.props.direct)}
              iconStyle={{ fill: '#FFFFFF'}}
              >
              <Room />
            </FloatingActionButton></div>}
            { ( (!this.props.isWebinar) || (this.props.publish_state_default) ) && !detectmob() && <div style={{display: "inline-block", marginRight: ".7rem"}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html
              />
            <FloatingActionButton
              data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    画面共有
                    ` : `
                    Screen Share
                  `}
                </div>`}
              backgroundColor={(this.props.screen_publish_state) ? '#FFFFFF' : ( this.props.isWebinar ? '#00bcd4' : isFVlite() ? '#009944' : (isSpacee() ? "rgb(255, 255, 255, 1)" : "#f6cc00" ))}
              onClick={(e) => this.props.handleListClick(e, 'share')}
              iconStyle={{ fill: (this.props.screen_publish_state) ? '#AFB9C5' : (isSpacee() ?  "rgb(112, 112, 112, 1)" : '#FFFFFF') }}
              >
              <ScreenShare />
            </FloatingActionButton></div>}
            { this.props.mode == "seminar" && this.props.role != "teacher" && <div style={{display: "inline-block", marginRight: ".5rem"}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
            <FloatingActionButton
              data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    発言申請をする
                    ` : `
                    Ask Question
                  `}
                </div>`}
              backgroundColor={(this.props.raise) ? '#FFFFFF' : '#00bcd4'}
              onClick={(e) => this.props.handleListClick(e, 'raise')}
              iconStyle={{ fill: (this.props.raise) ? '#AFB9C5' : '#FFFFFF' }}
              >
              <Help />
            </FloatingActionButton></div>}
            { ( (!this.props.isWebinar) || (this.props.publish_state_default) ) && <div className="videoAttr" style={{display: "inline-block", marginRight: ".7rem"}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
            <FloatingActionButton
            className="btnSmallMobile"
            data-tip={!detectmob() ? `
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    デバイスの設定
                    ` : `
                    Device Setting
                  `}
                </div>` : ""}
              backgroundColor={( this.props.isWebinar ? '#00bcd4' : isFVlite() ? '#009944' : (isSpacee() ? "rgb(255, 255, 255, 1)" : "#f6cc00" ) )}
              onClick={(e) => this.props.handleListClick(e, 'settings')}
              iconStyle={{fill: isSpacee() ?  "rgb(112, 112, 112, 1)" : "#FFFFFF"} }
              >
              <Settings />
            </FloatingActionButton> </div>}
            { ( (!this.props.isWebinar) || (this.props.publish_state_default) ) && <div className="videoAttr" style={{display: "inline-block", marginRight: ".7rem"}}>
              <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
              <FloatingActionButton
              className="btnSmallMobile"
              data-tip={!detectmob() ?
                `<div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    映像のミュート
                    ` : `
                    Mute Video ON/OFF
                  `}
                </div>`: "" }
              backgroundColor={(this.props.muteVideo) ? '#FFFFFF' : ( this.props.isWebinar ? '#00bcd4' : isFVlite() ? '#009944' : (isSpacee() ? "rgb(255, 255, 255, 1)" : "#f6cc00" ) )}
              onClick={(e) => this.props.handleListClick(e, 'video')}
              iconStyle={{ fill: (this.props.muteVideo) ? '#AFB9C5' : (isSpacee() ?  "rgb(112, 112, 112, 1)" : '#FFFFFF') }}
              >
              {(this.props.muteVideo) ?  <VideoOff />: <Video />}
            </FloatingActionButton> </div>}
            {  ( (!this.props.isWebinar) || (this.props.publish_state_default) ) && <div className="videoAttr" style={{display: "inline-block", marginRight: ".7rem"}}>
             <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html />
            <FloatingActionButton
              className="btnSmallMobile"
              data-tip={!detectmob() ? `
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    音声のミュート
                    ` : `
                    Mute Audio ON/OFF
                  `}
                </div>`: ""}
              backgroundColor={(this.props.muteAudio) ? '#FFFFFF' : ( this.props.isWebinar ? '#00bcd4' : isFVlite() ? '#009944' : (isSpacee() ? "rgb(255, 255, 255, 1)" : "#f6cc00" ))}
              onClick={(e) => this.props.handleListClick(e, 'mic')}
              iconStyle={{ fill: (this.props.muteAudio) ? '#AFB9C5' : (isSpacee() ?  "rgb(112, 112, 112, 1)" : '#FFFFFF')  }}
              >

              {(this.props.muteAudio) ? <MicOff /> : <Mic />}
            </FloatingActionButton>
            </div>}
            { !this.props.isWebinar && !detectmob() && (
              <div className="videoAttr" style={{display: "inline-block", marginRight: ".7rem"}}>
                <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html />
                <FloatingActionButton
                  data-tip={`
                    <div
                      class='pb2 custom-tooltip'>
                      ${(checkJapanese()) ? `
                        ローカル録画
                        ` : `
                        ${this.props.isRecording ? 'Stop' : 'Start'} Recording
                      `}
                    </div>`}
                  backgroundColor={(this.props.isRecording) ? '#FFFFFF' : ( this.props.isWebinar ? '#00bcd4' : isFVlite() ? '#009944' : "#f6cc00" )}
                  onClick={(e) => this.props.handleListClick(e, 'record')}
                  iconStyle={{ fill: (this.props.isRecording) ? '#AFB9C5' : '#FFFFFF' }}
                >
                  {
                    this.props.isRecording ? (
                      <div className="flex justify-center items-center" >
                        <Recording style={{ fill: 'red'}} />
                        <RecordingTime>
                          {getTimeFromSeconds(this.props.recordingTime)}
                        </RecordingTime>
                      </div>
                    ) : <NotRecording />
                  }
                </FloatingActionButton>
              </div>
            )}
            <div className="videoEnd" style={{display: "inline-block", marginRight: ".7rem"}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html />
              <FloatingActionButton
                data-tip={!detectmob() ? `
                  <div
                    class='pb2 custom-tooltip btnVideo'>
                    ${(checkJapanese()) ? `
                    ${(this.props.isWebinar ? "セミナーの終了" : "退出")}
                      ` : `
                      End Seminar
                    `}
                  </div>` : ""}
                backgroundColor={isFVlite() ? '#e25aa6eb' : '#F01631'}
                onClick={(e) => {
                  if (this.props.role == "teacher" && this.props.mode == "seminar") {
                    this.props.handleListClick(e, 'end');
                  } else {
                    if (window.confirm("本当に退出しますか?")) {
                      window.location = "/"
                      return 
                    }
                  }
                }}
                className='ml3 mr3 float-flat-button'
                style={{ width: 100, borderRadius: '40px' }}>
                <Phone style={{ transform: 'rotate(134deg)' }} />
              </FloatingActionButton>
            </div>
          </div> }
          <div className='mr1 chatBoxMobile' style={checkMobile() ? {} : { height: '8vh',position:'absolute', bottom: "5vh", zIndex: 150,right:'0px'}}>
          { !this.props.isOpenDrawer && this.props.notify_count != 0 ? <a id="mark" style={{color: "white",position:"relative"}}>
              <span style={{right: "30px",width: "18px"}} className="ft_pop ft_m ft_wg messageCount">{this.props.notify_count}</span>
          </a> :  <a id="dummy" >
              <span style={{right: "30px"}} ></span>
          </a> }
            <FloatingActionButton
            aria-label="vfgfd"
            className="btnSmallMobile"
              data-tip={!detectmob() ?`
              <div
                class='pb2 custom-tooltip btnVideo'>
                ${(checkJapanese()) ? `
                チャット
                  ` : `
                  Chat
                `}
              </div>` : ""}
              onClick={this.handleToggle}
              iconStyle={{ fill : isSpacee() ? "rgb(112, 112, 112, 1)" : '#FFFFFF' }}
              backgroundColor={isFVlite() ? "#009944" : isSpacee() ? "rgb(255, 255, 255, 1)" : "#46CE90" }>
              <ChatIcon />
            </FloatingActionButton>
          </div>
        </div>

        <Drawer
          className="drawerChat"
          containerStyle={{overflow: 'hidden'}}
          openSecondary
          width= '100%'
          open={this.props.isOpenDrawer}
          >
          <div
            className='flex justify-end pa3 items-center chat-header'
            style={{ 
              height: '9vh', 
              backgroundColor: this.props.isWebinar ? '#4688f1' : isFVlite() ? "#4AC6C3" : null, 
              backgroundImage: backgroundImage()  }}>
            <IconButton
              onClick={this.handleClose}
              iconStyle={{fill: '#FFFFFF'}}>
              <Clear className="clear-style"/>
            </IconButton>
          </div>
          <div>
            <SeminarTabs isWebinar={this.props.isWebinar} location={this.props.location} mode={this.props.mode} break_join={this.props.break_join} remoteList={this.props.remoteList} raiseList={this.props.raiseList} handleListClick={this.props.handleListClick} handleChat={this.props.handleChat} user_name={this.props.user_name} chat={this.props.chat} groupList={this.props.groupList} group={this.props.group} groupListObj={this.props.groupListObj} />
          </div>
        </Drawer>
      </div>
    );
  }
}

const RecordingTime = styled.span`
  background-color: red;
  color: white;
  border: 2px solid white;
  border-radius: 3px;
  position: absolute;
  height: 22px;
  width: 40px;
  font-size: 14px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;


const backgroundImage = () => {
  if(isSpacee()){
    return "linear-gradient( to right bottom, #4CB89C, #1A96D5 )"
  }
  if(isFVlite()){
    return "linear-gradient( to left bottom, #E3FEF1,#4AC6C3 )"
  }
  if(!isWebinar()){
    return "linear-gradient(135deg, rgba(255, 31, 14, 0.8) 0%, rgba(255, 47, 244, 0.8) 30%, rgba(255, 139, 22, 0.8) 90%, rgba(255, 213, 25, 0.8) 100%)"
  }
}

export default enhanceWithClickOutside(FloatingButtons);



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/FloatingButtons.js